import { getCookie } from "../cookies"
import { setCookie } from "../cookies"
import { removeCookie } from "../cookies"
import displayAmount from "./currencyConverter"
import rangeSlider from "rangeslider-pure"
import loadData from "./loadData";
import updateSliderPosition from "./updateSliderPos"

const calculator = document.querySelector('.calculator');

if (calculator) {

		const cookiePath = { path: "/" };
		let cookieAmount = getCookie('amount'),
				cookieMonth = getCookie('months');

		const slider = document.querySelectorAll('input[type="range"]');

		//// Values
		let inputAmount = document.querySelector("input[name=start-amount]").value;
		let inputMonth = document.querySelector("input[name=start-month]").value;
		let monthName = document.querySelector("input[name=month-name]").value;
		let currencyName = document.querySelector("input[name=currency-name]").value;

		let sliderAmountCounterMin = document.querySelectorAll(".loan-amount--min"),
				sliderAmountCounterMax = document.querySelectorAll(".loan-amount--max");

		let sliderAmount = document.querySelector("input.slider-amount"),
				sliderAmountMin = sliderAmount.min,
				sliderAmountMax = sliderAmount.max,
				sliderAmountCurrent = sliderAmount.value;

				

		let sliderMonth = document.querySelector("input.slider-month"),
				sliderMonthMin = sliderMonth.min,
				sliderMonthMax = sliderMonth.max,
				sliderMonthCurrent = sliderMonth.value,
				interestFreeMonths = document.querySelector(".calc-loan-total-interest-free-months");

		// Format currency min/max
		let amountMin = document.querySelector('.amount-min');
		let amountMinInner = amountMin.innerHTML;
		let amountMax = document.querySelector('.amount-max');
		let amountMaxInner = amountMax.innerHTML;

		amountMin.innerHTML = displayAmount(amountMinInner);
		amountMax.innerHTML = displayAmount(amountMaxInner);

		for (let i = 0; i < sliderAmountCounterMin.length; i++) {
				let sliderAmountMinVal = sliderAmountCounterMin[i].innerHTML;
				sliderAmountCounterMin[i].innerHTML = displayAmount(sliderAmountMinVal);
		}

		for (let i = 0; i < sliderAmountCounterMax.length; i++) {
				let sliderAmountMaxVal = sliderAmountCounterMax[i].innerHTML;
				sliderAmountCounterMax[i].innerHTML = displayAmount(sliderAmountMaxVal);
		}



		// Initialize a new plugin instance for one element or NodeList of elements.

		rangeSlider.create(slider, {
				polyfill: true,
				onInit: function (position, value) {
				},
				onSlideStart: function (position, value) {
				},
				onSlide: function (position, value) {
						let sliderAmountCounter = document.querySelectorAll('.calc-loan-amount');
						let sliderMonthCounter = document.querySelectorAll('.calc-loan-term');
						sliderMonthCurrent = sliderMonth.value;
						sliderAmountCurrent = sliderAmount.value;


						if (this.element.classList == "slider-amount") {
								// update displayed amount 
								for (let i = 0; i < sliderAmountCounter.length; i++) {
										sliderAmountCounter[i].innerHTML = displayAmount(position.toString());
								}
								// Load json data (loaddata(amount, month)
								loadData(position, sliderMonthCurrent)
						}
						if (this.element.classList == "slider-month") {
								for (let i = 0; i < sliderMonthCounter.length; i++) {
										sliderMonthCounter[i].innerHTML = position + monthName;
								};
								// Load json data (loaddata(amount, month))
								loadData(sliderAmountCurrent, position)
						}

				},
				onSlideEnd: function (position, value) {
						if (this.element.classList == "slider-amount") {
								loadData(position, sliderMonthCurrent)
								setCookie("amount", position, cookiePath)
						} else if (this.element.classList == "slider-month") {
								loadData(sliderAmountCurrent, position)
								setCookie("months", position, cookiePath)
						} else if (this.element.classList == "slider-interest") {
								setCookie("interestFreeDays", position, cookiePath)
						}

						updateSliderPosition();
				}				
		});

		if (cookieAmount && cookieMonth) {
				sliderAmountCurrent = cookieAmount;
				sliderMonthCurrent = cookieMonth;
				loadData(cookieAmount, cookieMonth)

		} else {
				setCookie("amount", sliderAmountCurrent, cookiePath);
				setCookie("month", sliderMonthCurrent, cookiePath);

				loadData(sliderAmountCurrent, sliderMonthCurrent)

				updateSliderPosition();
		}

		// Amount
		let amount = document.querySelector(".amount");
		let rangeSlider__handle_amount = amount.querySelector(".rangeSlider__handle");

		// Terms
		let terms = document.querySelector(".term");
		let rangeSlider__handle_term = terms.querySelector(".rangeSlider__handle");

		//Create elements
		var amountNode = document.createElement("SPAN");
		var monthNode = document.createElement("SPAN");

		//Texts and classes
		if (rangeSlider__handle_amount) {
				var textstring = document.createTextNode(displayAmount(inputAmount));
				amountNode.className = "calc-loan-amount";
				amountNode.appendChild(textstring);

				//Amount
				rangeSlider__handle_amount.appendChild(amountNode);
		}

		if (rangeSlider__handle_term) {
				var termText = document.createTextNode(inputMonth + monthName);
				monthNode.className = "calc-loan-term";
				monthNode.appendChild(termText);

				rangeSlider__handle_term.appendChild(monthNode);
		}

		let sliderAmountCounter = document.querySelectorAll('.calc-loan-amount'),
				sliderMonthCounter = document.querySelectorAll('.calc-loan-term');

		// Get cookie values if present and display frontend & set cookie path so we don't get duplicates


		if (cookieAmount) {
				for (let i = 0; i < sliderAmountCounter.length; i++) {
						sliderAmountCounter[i].innerText = displayAmount(cookieAmount);
				}
		} else {
				for (let i = 0; i < sliderAmountCounter.length; i++) {
						let inner = sliderAmountCounter[i].innerText;
						sliderAmountCounter[i].innerText = displayAmount(inner);
				}
		}
		if (cookieMonth) {
				for (let i = 0; i < sliderMonthCounter.length; i++) {
						sliderMonthCounter[i].innerHTML = cookieMonth + monthName
				}
		}

		// Reset cookies with new values
		if (cookieAmount) {
				for (let i = 0; i < sliderAmountCounter.length; i++) {
						sliderAmountCounter[i].innerHTML = displayAmount(cookieAmount);
				}
				sliderAmountCurrent = cookieAmount;
		} else {
				setCookie("amount", sliderAmountCurrent, cookiePath);
		}
		if (cookieMonth) {
				sliderMonthCurrent = cookieMonth;

				for (let i = 0; i < sliderMonthCounter.length; i++) {
						sliderMonthCounter[i].innerHTML = cookieMonth + monthName;
				}
		} else {
				setCookie("months", sliderMonthCurrent, cookiePath)
		}
}
updateSliderPosition();





